/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FacilitySettingValue } from './FacilitySettingValue';
import {
    FacilitySettingValueFromJSON,
    FacilitySettingValueFromJSONTyped,
    FacilitySettingValueToJSON,
} from './FacilitySettingValue';

/**
 * 
 * @export
 * @interface GetOneFacilitySetting200Response
 */
export interface GetOneFacilitySetting200Response {
    /**
     * 
     * @type {FacilitySettingValue}
     * @memberof GetOneFacilitySetting200Response
     */
    data?: FacilitySettingValue;
}

/**
 * Check if a given object implements the GetOneFacilitySetting200Response interface.
 */
export function instanceOfGetOneFacilitySetting200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function GetOneFacilitySetting200ResponseFromJSON(json: any): GetOneFacilitySetting200Response {
    return GetOneFacilitySetting200ResponseFromJSONTyped(json, false);
}

export function GetOneFacilitySetting200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetOneFacilitySetting200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : FacilitySettingValueFromJSON(json['data']),
    };
}

export function GetOneFacilitySetting200ResponseToJSON(value?: GetOneFacilitySetting200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': FacilitySettingValueToJSON(value.data),
    };
}

